import React from "react";
import styles from "src/components/molecules/ListItem/styles.module.css";
import cx from "classnames";
import EmptyAvatar from "src/assets/images/emptyAvatar.svg";
import Avatar from "src/assets/images/avatar.svg";

import { format } from "date-fns";
import { ru } from "date-fns/locale";
import { CryptoCoin } from "src/components/atoms/CryptoCoin";

type Props = {
  img?: string;
  title: string;
  time?: string;
  info: string;
  notification?: boolean;
  win?: boolean;
  id: string;
  link?: string;
  onClick?: (id: string) => void;
  isWithdraw?: boolean;
  showTokenIcon?: boolean;
  isPlus?: boolean;
};

export const ListItem: React.FC<Props> = ({
  img,
  title,
  time,
  info,
  notification,
  win,
  link,
  onClick,
  id,
  isWithdraw,
  showTokenIcon,
  isPlus,
}) => {
  const formatted = time
    ? format(new Date(time), "dd MMMM yyyy, HH:mm", {
        locale: ru,
      })
    : null;
  const handleRedirect = () => {
    onClick?.(id);
    if (link) {
      window.open(link, "_blanck");
    }
  };
  return (
    <div
      className={cx(styles.listItem, {
        [styles.notificationListItem]: notification,
      })}
      onClick={handleRedirect}
      role="button"
    >
      <div className={styles.img}>
        <img src={img ? img : notification ? Avatar : EmptyAvatar} alt="img" />
      </div>
      <div className={styles.info}>
        <div className={styles.title}>
          <h5>{title}</h5>
          {formatted && <span>{formatted}</span>}
        </div>
        {notification ? (
          <div
            className={cx(styles.winText, {
              [styles.win]: win && isWithdraw,
              [styles.defet]: !win && win !== null && isWithdraw,
            })}
          >
            {isWithdraw && (
              <div className={cx(styles.round)}> {win ? "+ " : "-"}</div>
            )}
            <p>
              {info}
              {isWithdraw && (
                <>
                  {" "}
                  <CryptoCoin fill={win ? "#27AE60" : "#ff4545"} />
                </>
              )}
            </p>
          </div>
        ) : (
          <p
            className={cx({
              [styles.successText]: showTokenIcon || isPlus,
              [styles.errorText]:
                isPlus !== undefined && isPlus === false && isPlus !== null,
            })}
          >
            {info} {showTokenIcon && <CryptoCoin fill="#27AE60" />}
          </p>
        )}
      </div>
    </div>
  );
};
